import Decimal from 'decimal.js';

export function receivingUnits(product) {
  const base = { name: product.base_unit || 'Pcs', pieces: 1 };
  const seen = new Set([base.name]);
  const units = (product.units || []).filter(unit => {
    if (!unit.name || seen.has(unit.name) || !Number.isInteger(Number(unit.pieces)) || Number(unit.pieces) <= 0) return false;
    seen.add(unit.name); return true;
  }).map(unit => ({ name: unit.name, pieces: Number(unit.pieces) }));
  const dus = units.find(unit => unit.name.trim().toUpperCase() === 'DUS');
  return dus ? [dus, base, ...units.filter(unit => unit !== dus)] : [base, ...units];
}
export const unitCost = (baseCost, pieces) => new Decimal(baseCost || 0).mul(pieces).toFixed();
export const switchUnitCost = (cost, oldPieces, newPieces) => cost === '' ? '' : new Decimal(cost).div(oldPieces).mul(newPieces).toFixed();
export function receivingPreview(product, form) {
  try {
    const qty = new Decimal(form.quantity), price = new Decimal(form.cost), factor = new Decimal(form.pieces);
    if (!qty.isInteger() || qty.lte(0) || factor.lte(0) || price.lt(0)) return null;
    const incoming = qty.mul(factor), baseCost = price.div(factor), oldStock = Decimal.max(0, product.stock || 0);
    return { stockIn: incoming.toFixed(), baseCost: baseCost.toFixed(),
      average: oldStock.mul(product.cost || 0).add(incoming.mul(baseCost)).div(oldStock.add(incoming)).toFixed(6) };
  } catch { return null; }
}
